(function () {
  'use strict';
  const bundles = Object.freeze({single:{paid:1,quantity:1},trio:{paid:2,quantity:3},six:{paid:3,quantity:6}});

  function detectMarket(pathname, data) {
    const segment=pathname.split('/').filter(Boolean)[0]?.toLowerCase() || '';
    for (const [country,market] of Object.entries(data.markets)) {
      if (market.urlSegments.includes(segment)) return {...market,country,segment};
    }
    return {...data.defaultMarket,country:null,segment:null};
  }

  function interpolate(value, params={}) {
    return String(value).replace(/\{([a-zA-Z]+)\}/g, (match,key)=>params[key] ?? match);
  }

  function chooseVariant(product, requestedId) {
    if (!product?.variants?.length || product.requires_selling_plan) return null;
    if (requestedId) return product.variants.find(v=>String(v.id)===String(requestedId)) || null;
    return product.variants.find(v=>v.available && !v.requires_selling_plan) || null;
  }

  function canOrder(variant, quantity) {
    const rule=variant?.quantity_rule || {};
    return Boolean(variant?.available && !variant.requires_selling_plan && quantity >= (rule.min || 1) && quantity <= (rule.max ?? Infinity) && quantity % (rule.increment || 1) === 0);
  }

  function calculatePrices(priceCents, sourceCurrency, targetCurrency, rates, shippingEurCents=499) {
    const rate=currency=>currency==='EUR'?1:rates[currency];
    if (![priceCents,shippingEurCents].every(Number.isFinite) || priceCents<=0 || shippingEurCents<0) throw new Error('Invalid product or shipping price');
    const sourceRate=rate(sourceCurrency),targetRate=rate(targetCurrency);
    if (![sourceRate,targetRate].every(n=>Number.isFinite(n)&&n>0)) throw new Error('Exchange rate unavailable');
    const unit=Math.round(priceCents/sourceRate*targetRate);
    const delivery=Math.round(shippingEurCents*targetRate);
    return Object.fromEntries(Object.entries(bundles).map(([key,bundle])=>{
      const price=unit*bundle.paid, regular=unit*bundle.quantity, shipping=key==='single'?delivery:0;
      return [key,{price,regular,shipping,total:price+shipping,perBottle:Math.round(price/bundle.quantity),saving:regular-price}];
    }));
  }

  function checkoutPath(rootUrl, variantId, bundle, market, discount='') {
    if (!/^\d+$/.test(String(variantId)) || !(bundle in bundles)) throw new Error('Invalid checkout product');
    const root=String(rootUrl || '/');
    if (!/^\/(?:[a-zA-Z-]+\/?)?$/.test(root)) throw new Error('Invalid storefront root');
    const query=new URLSearchParams();
    query.set('locale',market.language || 'en');
    if (market.country) query.set('checkout[shipping_address][country]',market.country);
    if (discount.trim()) query.set('discount',discount.trim());
    return `${root.endsWith('/')?root:root+'/'}cart/${variantId}:${bundles[bundle].quantity}?${query}`;
  }

  globalThis.GlycoraCore=Object.freeze({bundles,detectMarket,interpolate,chooseVariant,canOrder,calculatePrices,checkoutPath});
})();
